import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 20 26',
    fill: 'currentColor',
    defaultAriaLabel: 'Document Icon',
};

export const DocumentCviIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <path d="M5 4C4.44772 4 4 4.44772 4 5C4 5.55229 4.44772 6 5 6H15C15.5523 6 16 5.55229 16 5C16 4.44772 15.5523 4 15 4H5Z" />
            <path d="M4 9C4 8.44772 4.44772 8 5 8H15C15.5523 8 16 8.44772 16 9C16 9.55229 15.5523 10 15 10H5C4.44772 10 4 9.55229 4 9Z" />
            <path d="M5 12C4.44772 12 4 12.4477 4 13C4 13.5523 4.44772 14 5 14H13C13.5523 14 14 13.5523 14 13C14 12.4477 13.5523 12 13 12H5Z" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18 26C19.1046 26 20 25.1046 20 24L20 2C20 0.895432 19.1046 0 18 0H2C0.895432 0 0 0.895432 0 2L0 24C0 25.1046 0.895431 26 2 26L18 26ZM18 24L2 24L2 2L18 2L18 24Z" />
        </SvgIcon>
    );
};
